import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const SupportButton: React.FC = () => {
  const { t, isRTL } = useLanguage();
  const [showNumber, setShowNumber] = useState(false);

  return (
    <>
      {/* Support Text Button */}
      <button
        onClick={() => setShowNumber(true)}
        className={`fixed top-5 ${isRTL ? 'left-4 sm:right-6 sm:left-auto' : 'right-4 sm:left-6 sm:right-auto'} z-50 px-4 py-2 rounded-full bg-[#2E5D7D] text-white text-sm font-medium shadow-lg hover:shadow-xl hover:opacity-90 transition-all duration-200`}
      >
        {t('support')}
      </button>

      {/* Phone Number Modal */}
      {showNumber && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50"
          onClick={() => setShowNumber(false)}
        >
          <div
            className="bg-white rounded-2xl p-6 max-w-sm w-full mx-4 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-lg font-semibold text-gray-900 mb-3 text-center">
              {t('support')}
            </h3>
            <p className="text-gray-600 mb-2 text-sm text-center">
              {t('support_message')}
            </p>
            <p className="text-gray-600 mb-4 text-sm text-center">
              {t('support_message_details')}
            </p>
            <a
              href="https://wa.me/9647821905425"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-center text-xl font-bold text-[#2E5D7D] mb-4 hover:underline"
              dir="ltr"
            >
              07821905425
            </a>
            <button
              onClick={() => setShowNumber(false)}
              className="w-full px-4 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-all"
            >
              {t('close')}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default SupportButton;
